import React,{ useEffect,useState } from 'react';
import { fetchAdminApi } from "../../../services/api";
import { Table, Button, message, Form, Tooltip, Space, Popconfirm, Radio, Spin, Collapse, Tag } from 'antd';
import { EditOutlined, DownloadOutlined, DeleteOutlined, LeftCircleOutlined, RightCircleOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import moment from "moment";
import constants from '../../../constants/constants';
import { DOB } from "../../../globalFunctions/GlobalFunctions";
import { COOKIE, getCookie } from "../../../services/cookie";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import NotesModal from '../../component/NotesModal';
const { Panel } = Collapse;
const NoteList =()=> {
	const history = useHistory();
	const [form] = Form.useForm();
	const [tableData, setTableData] = useState([]);
	const [totalAdminSession, setTotalAdminSession] = useState([]);
	//notes
	const [notesVisible, setnotesVisible] = useState(false);
	const [noteValue, setNoteValue] = useState(null);
	const [noteTypeValue, setNoteTypeValue] = useState("0");
	const [sectionId, setSectionId] = useState(null);
	const [sessionChecked, setSessionChecked] = useState(false);
	const [isSessionPresent, setIsSessionPresent] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [noteId, setNoteId] = useState("");
	const [loader, setLoader] = useState(true);
	const [isDisableNoteType, setIsDisableNoteType] = useState(false);
	const [editNoteIndex, setEditNoteIndex] = useState("");
	const [disableNext, setDisableNext] = useState(false);
	const [disablePrevious, setDisablePrevious] = useState(false);
	const [noteView, setNoteView] = useState("listView");
	const [notefollowUp, setNoteFollowUp] = useState(false);
	const [assessmentBehavior, setAssessmentBehavior] = useState([]);
	const loginType = getCookie(COOKIE.LoginType);
	const [pagination, setPagination] = useState({
		current: 1,
		pageSize: 25,
		pageSizeOptions: [10, 25, 50, 100]
	});
	const defaultPaginationBook = {
		current: 1,
		pageSize: 1,
	};
	const defaultPagination = {
		current: 1,
		pageSize: 25,
		pageSizeOptions: [10, 25, 50, 100]
	};
	const current = new Date();
	const [noteDate,setNoteDate] = useState({
		date: current.getDate(),
		month: String(current.getMonth() + 1).padStart(2, '0'),
		year: current.getFullYear()
	});
	//date of notes date onchange
	const handleNoteDayChange = (value) => {
		setNoteDate({
			...noteDate,
			date:value
		});
	};
	const handleNoteMonthChange = (value) => {
		setNoteDate({
			...noteDate,
			month:value
		});
	};
	const handleNoteYearChange = (value) => {
		setNoteDate({
			...noteDate,
			year:value
		});
	};
	const onFollowUpChange = (checked) => {
		setNoteFollowUp(checked);

		const firstName = adminClientValuefromSession?.client_name || "Client";

		if (checked) {
			onchangeNoteValue(constants.FollowUpData1 + `${firstName || "Client"}` + constants.FollowUpData2, 0);
			onchangeNoteValue(constants.FollowUpAssessment, 1);
			onchangeNoteValue(constants.FollowUpPlan, 2);
		} else {
			onchangeNoteValue("", 0);
			onchangeNoteValue("", 1);
			onchangeNoteValue("", 2);
		}
	};

	const adminClientValuefromSession = JSON.parse(sessionStorage.getItem("adminClientValue"));
	const handleDelete = (notes_id) => {
		fetchAdminApi(`/delete-note/${notes_id}`, "delete").then((res) => {
			if (res?.code === 200) {
				message.success(res?.message);
				fetchNotes("delete");
			} 
			else {
				message.error(res?.message);
			}
		});
	}
	const canEditNote = (note, loginType, currentAdminId) => {
		// If the note is signed in any way, block editing
		if (note?.signed_on || note?.signed_by || note?.signed_by_name) {
			return false;
		}

		// Main admin (loginType === "1") can edit any unsigned note
		if (loginType === "1") {
			return true;
		}

		// Associate (loginType === "2") can edit their own unsigned notes only
		if (loginType === "2") {
			return note?.admin_id === String(currentAdminId);
		}

		// All others: no access
		return false;
	};
	const columns = [
		{
			title: 'Action',
			width: "5%",
			align: "center",
			render: (_, record) => {
				let adminId = getCookie(COOKIE.ClientId);
				let noteIndex = tableData?.findIndex((val) => val?.notes_id === record?.notes_id);
				const isEditable = canEditNote(record, loginType, adminId);

				return <Space>
					{isEditable ?
						<Tooltip title={"Edit"}><Button
							onClick={() => record?.notes_type === "0" || record?.notes_type === "8" ? addNotes("edit", record, noteIndex) : navigateTo(record)}
							type='text'
							icon={<EditOutlined />}
						/></Tooltip> : null
					}
					<Tooltip title={"Delete"}>
						<Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record?.notes_id)}>
							<Button
								type='text'
								icon={<DeleteOutlined />}
							/>
						</Popconfirm>
					</Tooltip>
					<Tooltip title={"Download"}><Button
						onClick={()=>downloadNotes(record)}
						type='text'
						icon={<DownloadOutlined/>}
					/></Tooltip>
				</Space>;
			}
		},
		{
			title: 'Date',
			dataIndex: 'date_of_notes',
			key: 'date_of_notes',
			render:(date,record)=>{
				return <div>
					<span>{moment(date).format(constants.dateformat)}</span>
					{
						record?.signed_by ?
							<><br /><br /><span>E-signed by {record?.signed_by_name} on {moment(record?.signed_on).format(constants.dateformat)}</span></> :
							<span></span>
					}
				</div>;
			},
			width:"10%"
		},
		{
			title: 'Intervention',
			dataIndex: 'intervention',
			key: 'intervention',
			render: (intervention) => {
				return <span className="m-auto">{intervention}</span>;
			},
			width:"5%"
		},
		{
			title: 'Content',
			dataIndex: 'notes_content',
			key: 'notes_content',
			// width:"80%",
			editable: true,
			render: (notes, record) => {
				const {
					notes_content,
					notes_assesment,
					notes_assesment_behaviour,
					notes_plan,
					notes_type,
					answers = {}
				} = record;

				const safeNotesContent = notes_content || '';
				const safeAssessment = notes_assesment || '';
				const safeAssessmentBehaviour = notes_assesment_behaviour || '';
				const safePlan = notes_plan || '';
				const planAdd = Array.isArray(answers?.plan_option) ? '' : (answers?.plan_option || '');
				const assessmentCombined = safeAssessment + safeAssessmentBehaviour;

				let planCombined = '';
				if (notes_type === "8" && (!notes_plan || notes_plan === '') && planAdd) {
					planCombined = `<b><u>PLAN:</u></b><h3>${planAdd}</h3>`;
				} else {
					planCombined = safePlan + planAdd;
				}

				const parts = [safeNotesContent, assessmentCombined, planCombined].filter(p => p && p.trim() !== '');
				const combinedContent = parts.join('<br/>');

				const contentDiv = document.createElement('div');
				contentDiv.innerHTML = combinedContent?.replace(/\n/g, '<br/>');
				const formattedHtml = contentDiv.innerHTML;

				// Notes type label map
				const notesTypeMap = {
					"0": "General",
					"1": "Addicts/Gamblers",
					"2": "Family Member",
					"3": "Emotional",
					"4": "Self-Assessment",
					"5": "Pre-Assessment",
					"6": "Recovery Plan",
					"7": "Screening",
					"8": "Group Notes",
					"9": "Discharge Plan",
					"10": "Admission Assessment",
				};

				let header = notesTypeMap[notes_type] || '';

				if (notes_type === "8" && answers?.group_name) {
					header += ` (${answers.group_name})`;
				}

				return (
				  <Collapse accordion>
					<Collapse.Panel header={header} key="1">
					  <div dangerouslySetInnerHTML={{ __html: formattedHtml || "" }} />
					</Collapse.Panel>
				  </Collapse>
				);
			  }
		},
		{
			title: 'Session',
			dataIndex: 'session',
			key: 'session',
			width: "5%",
			render: (session) => {
				return <span className="text-right w-6 block m-auto">{session}</span>;
			}
		},
		{
			title: 'Section',
			dataIndex: 'section_id',
			key: 'section_id',
			width: "10%",
			render: (section) => {
				const sectionId = Number(section);

				let sectionName;

				if (sectionId >= 400 && sectionId < 500) {
					sectionName = `Residential ${sectionId - 400}`;
				} else if (sectionId >= 300) {
					sectionName = `IOP - TSF ${sectionId - 300}`;
				} else if (sectionId >= 200 && sectionId < 300) {
					sectionName = `Harm Reduction ${sectionId - 200}`;
				} else if (sectionId >= 1 && sectionId < 100) {
					sectionName = `Immersion ${sectionId}`;
				} else {
					sectionName = section;
				}

				return (
					<span className="text-left block m-auto">
						{sectionName}
					</span>
				);
			}
		},
		{
			title: 'Entered By',
			dataIndex: 'note_by_name',
			key: 'note_by_name',
			width:"10%",
			render: (name) => {
				return <span className="m-auto">{name}</span>;
			}
		},
	];
	const navigateTo = (record) => {
		if (record?.notes_type === "5") {
			history.push({
				pathname: "/edit-pre-assessment-intake",
				state: record
			});
		}else if (record?.notes_type === "4") {
			let payload = JSON.parse(sessionStorage.getItem("adminClientValue"));
			payload.answers = record?.answers
			payload.notes_id = record?.notes_id
			payload.date_of_notes = record?.date_of_notes

			sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
			history.push({
				pathname: "/edit-self-assessment-summary",
				state: payload
			});
		} else if (record?.notes_type === "10") {
			window.open(constants.BaseUrl + "/admission-assessment-form");
		} else {
			history.push({
				pathname: "/edit-note",
				state: record
			});
		}
	};
	const nextPreviousButton = () => {
		return isEdit ?
		<div className='flex'>
			<Tooltip placement="bottom" title={constants.Previous}><Button disabled={disablePrevious} type='text' icon={<LeftCircleOutlined />} onClick={()=>addNotes("edit",tableData[editNoteIndex-1],editNoteIndex-1,)}/*  onClick={()=>onNextandPrev("previous")} */ /></Tooltip>
			<Tooltip placement="bottom" title={constants.Next}><Button disabled={disableNext} type='text' icon={<RightCircleOutlined />} onClick={()=>addNotes("edit", tableData[editNoteIndex + 1], editNoteIndex+1)} /* onClick={()=>onNextandPrev("next")} *//></Tooltip>
		</div> : null
	}
	useEffect(() => {
		const noteViewValue = JSON.parse(sessionStorage.getItem('noteViewValue'));
		if (noteViewValue?.noteView && noteViewValue?.noteId) {
			fetchNotes(null, noteViewValue?.noteId);
			setNoteView(noteViewValue?.noteView);
			sessionStorage.removeItem('noteView');
		}
		else {
			fetchNotes();
		}
	}, []);
	const fetchNotes = (type=null, note_Id) => {
		setLoader(true);
		let payload;
		if (adminClientValuefromSession?.clientId) {
			payload = {
				client_id: adminClientValuefromSession?.clientId,
				enquiry_id: adminClientValuefromSession?.enquiryId,
			};
		} else {
			payload = { enquiry_id: adminClientValuefromSession?.enquiryId };
		}
		fetchAdminApi(`/client-notes`, "post",payload).then((res) => {
			if (res && res.code && res.code === 200) {
				setTableData(res?.data?.notes_result);
				setTotalAdminSession(res?.data?.total_sessions);
				if (note_Id) {
					const index = findIndexByNoteId(note_Id, res?.data?.notes_result);
					if (index !== -1) {
						setPagination({ ...pagination, current: index + 1, pageSize: 1 });
					} else {
						setPagination({ ...pagination, current: 1, pageSize: 1 });
					}
				}
				setLoader(false);
			} 
			else {
				setTotalAdminSession([]);
				setTableData([]);
				setLoader(false);
			}
		});
	};
	const findIndexByNoteId = (noteId, data) => {
		for (let i = 0; i < data?.length; i++) {
			if (data[i]?.notes_id === String(noteId)) {
				return i;
			}
		}
		return -1;
	};
	const hideModal = () => {
		setNoteValue(null);
		setNoteTypeValue("0");
		setnotesVisible(false);
		setNoteFollowUp(false);
		setSessionChecked(false);
	};
	const onchangeNoteValue = (e,index) => {
		const hasContent = e.replace(/<\/?[^>]+(>|$)/g, '').trim().length > 0;
		if(hasContent){
			noteValue[index] = e;
		}else{
			noteValue[index] = null;
		}
		
	};
	const addNotes = (type, record, noteindex = null) => {
		const is_note_answered = tableData.some(note =>
			["1", "2", "3", "4"].includes(note.notes_type)
		);

		if (type !== "edit") {
			// Navigate to add-note page
			window.open(constants.BaseUrl + "/add-note");
		} else if (type === "edit" && record) {
			// Navigate to edit-note page with cleaned up data
			history.push({
				pathname: "/edit-note",
				state: {
					...record,
					notes_content: record?.notes_content ? record.notes_content.replace(/<p[^>]*>.*?Group Note.*?<\/p>/gi, '').replace(/<b><u>DATA:<\/u><\/b>\s*/gi, '').trim(): "",
					notes_assesment: record?.notes_assesment ? record?.notes_assesment.replace(/<b><u>ASSESSMENT:<\/u><\/b>\s*/gi, '').trim() : "",
					notes_plan: record?.notes_plan ? record?.notes_plan.replace(/<b><u>PLAN:<\/u><\/b>\s*/gi, '').trim() : "",
				}
			});
		}
	};
	const createNote =(type)=>{
		let admin_id = getCookie(COOKIE.ClientId);
		let assessmentText = '';
		if (noteValue[1]) {
			assessmentText = "<b><u>ASSESSMENT:</u></b> " + noteValue[1];
		} else if (assessmentBehavior?.length > 0) {
			assessmentText = "<b><u>ASSESSMENT:</u></b> ";
		}

		const hasAssessment = !!noteValue[1];
		const hasBehaviors = assessmentBehavior?.length > 0;
		const clientName = adminClientValuefromSession?.client_name || "Client";

		let payload={
			notes_content: noteValue[0] ? "<b><u>DATA:</u></b>" + " " +noteValue[0]: "",
			notes_assesment: assessmentText,
			notes_plan: noteValue[2] ? "<b><u>PLAN:</u></b>" + " " +noteValue[2]: "",
			section_id: sectionId,
			admin_id:admin_id,
			notes_type:noteTypeValue,
			dt_created:`${noteDate.year}-${noteDate.month}-${noteDate?.date}`
		};
		if (noteTypeValue === "0") {
			const behaviorSentence = hasBehaviors
				? `<h3>${clientName} ${assessmentBehavior?.join(', ')}.</h3>`
				: '';

			payload.notes_assesment_behaviour = behaviorSentence;
			payload.answers = {
				...(payload.answers || {}),
				follow_up: notefollowUp ? 1 : 0,
				assessment_behavior: assessmentBehavior
			};
		}
		if (sessionChecked === true) {
			payload.session_checked = sessionChecked;
		}
		if(adminClientValuefromSession?.clientId){
			payload.client_id =   adminClientValuefromSession?.clientId;
		}else{
			payload.enquiry_id = adminClientValuefromSession?.enquiryId;
		}
		if(type === "esign"){
			payload.signed_by = admin_id;
		}
		let url;
		let method;
		if(isEdit){
			url = `/edit-notes`;
			method = 'put';
			payload.notes_id = noteId;
		}else{
			url = `/add-notes`;
			method = 'post';
		}
		if(noteValue !== null){
			fetchAdminApi(url, method, payload).then((res) => {
				if (res && res.code && res.code === 200) {
					if(isEdit){
						fetchNotes("edit");
					}else{
						fetchNotes();
					}
					setNoteDate({
						...noteDate,
						date: current.getDate(),
						month: String(current.getMonth() + 1).padStart(2, '0'),
						year: current.getFullYear()
					});
					setAssessmentBehavior([]);
					message.success(res.message);
				} else {
					message.error(res.message);
				}
			});
		}
		hideModal();
	};
	const getForm = (formType) => {
		setNoteTypeValue(formType);
		let payload = { note_type: formType };
		if(adminClientValuefromSession?.clientId){
			payload.client_id =   adminClientValuefromSession?.clientId;
		}else{
			payload.enquiry_id = adminClientValuefromSession?.enquiryId;
		}
		fetchAdminApi("/notes",'post',payload).then((res) => {
			if (res?.code === 200) {
				setNoteValue(res?.data?.data);
				if(res?.data?.is_note_answered === 1){
					setIsDisableNoteType(true);
				}else{
					setIsDisableNoteType(false);
				}
			}else{
				setNoteValue([]);
			}
		});
	};
	const downloadNotes = (notesValue) => {
		let notesPayload={
			notes_id : notesValue?.notes_id,
			notes_assesment : 1
		};
		if(notesValue?.client_id !== null){
			notesPayload.client_id = notesValue?.client_id;
		}else{
			notesPayload.enquiry_id = adminClientValuefromSession?.enquiryId;
		}
		let documentValue={ 
			file_type : "notes-pdf",
			notes_payload : notesPayload
		};
		sessionStorage.setItem("documentValue",JSON.stringify(documentValue));
		window.open(constants.BaseUrl + `/view-document`);
	};

	const totalRecords = Math.ceil(tableData?.length);
	const onPreviousPage = () => {
		setPagination({
			...pagination,
			current: pagination.current - 1
		});
	};
	const onNextPage = () => {
		setPagination({
			...pagination,
			current: pagination.current + 1
		})
	};

	const onChangeNoteView = (value) => {
		setNoteView(value);
		if (value === "bookView") {
			setPagination(defaultPaginationBook);
		} else {
			setPagination(defaultPagination);
		}
	};

	const viewNoteOption = [
		{
			label: 'List View',
			value: 'listView',
		},
		{
			label: 'Book View',
			value: 'bookView',
		},
	];

	const onChangeTable = (pagination, paginationBook, sort, filter) => {
		setPagination(pagination);
	};

	const onSessionChange = (value) => {
		setSessionChecked(value);
	}

	const handleAssessmentBehaviorChange = (value) => {
		setAssessmentBehavior(value);
	}

	const handleBackClick = () => {
		if (history.length > 1) {
			history.goBack();
		} else {
			handleRedirect();
		}
	};
	const handleRedirect = () => {
		if (adminClientValuefromSession?.enquiry_id) {
			history.push("/view-enquiry");
		} else {
			history.push("/view-client");
		}
	};

	return (
		<div>
			<div className='text-center bg-amber-300 text-lg font-semibold p-3'>{constants.Subtitle}
				<span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl">Notes</span>
			</div>
			<div className='bg-amber-100 text-base font-semibold p-2 mb-3'><div className="container mx-auto">
				<Space size={'small'} wrap direction="vertical">
					<span>Notes - {`${adminClientValuefromSession?.client_name ? adminClientValuefromSession?.client_name : ""} (#${adminClientValuefromSession?.client_serial_number ? adminClientValuefromSession?.client_serial_number : ""})`}</span>
					<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={handleBackClick}>{constants.BackBtn}</Button>
				</Space>
			</div></div>
			<div className='container mx-auto'>
				<Form form={form} component={false}>
					<div className='mb-2 flex justify-between'>
						<Space>
							<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={() => addNotes("add", null)}>{constants.AddNote}</Button>
							<Radio.Group
								options={viewNoteOption}
								onChange={(e) => onChangeNoteView(e.target.value)}
								value={noteView}
								optionType="button"
								buttonStyle="solid"
								size='small'
								className='client-details font-semibold uppercase'
								rowKey="notes_id"
							/>
						</Space>
						{totalRecords > 0 && (
							<div>
								<Tooltip placement="bottom" title={constants.Previous}>
									<Button
										size='large'
										disabled={pagination.current === 1}
										type='text'
										onClick={onPreviousPage}
										icon={<LeftOutlined className='text-base' />}
									/>
								</Tooltip>
								<Tooltip placement="bottom" title={constants.Next}>
									<Button
										size='large'
										disabled={pagination.current === Math.ceil(totalRecords / pagination.pageSize)}
										type='text'
										onClick={onNextPage}
										icon={<RightOutlined className='text-base' />}
									/>
								</Tooltip>
							</div>
						)}
					</div>
					<div className='mb-2'>
					<div className="flex flex-col sm:flex-row items-start !gap-1 sm:gap-4">
						<div className="sm:min-w-[140px] font-semibold text-gray-800">
							{constants.NonBillable} :
						</div>
						<div className="flex flex-wrap gap-2">
							{totalAdminSession?.non_billable?.length > 0 ? (
								totalAdminSession?.non_billable?.map((val, index) => (
									<div
										key={index}
										className="flex items-center gap-1 bg-white px-3 py-1 rounded shadow text-sm"
									>
										<span className="font-semibold text-gray-800">{val.name}</span>
										<span className="text-gray-500">:</span>
										<span className="text-gray-800 font-medium">{val.notes}</span>
									</div>
								))
							) : (
								null
							)}
						</div>
					</div>
				</div>
				<div className='mb-2'>
					<div className="flex flex-col sm:flex-row items-start !gap-1 sm:gap-4">
						<div className="sm:min-w-[140px] font-semibold text-gray-800">
							{constants.Billable} :
						</div>
						<div>
							<div className="flex flex-wrap gap-2">
								{totalAdminSession?.billable?.length > 0 ? (
									totalAdminSession?.billable?.map((val, index) => (
										<div
											key={index}
											className="flex items-center gap-1 bg-white px-3 py-1 rounded shadow text-sm"
										>
											<span className="font-semibold text-gray-800">{val.name}</span>
											<span className="text-gray-500">:</span>
											<span className="text-gray-800 font-medium">{val.notes}</span>
										</div>
									))
								) : (
									null
								)}
							</div>
						</div>
					</div>
				</div>
					<Spin spinning={loader} size="large">
						<div className='overflow-auto'>
						<Table
							className='borderTable'
							dataSource={tableData}
							columns={columns}
							onChange={onChangeTable}
							pagination={
								noteView === "listView" ? pagination : {
									...pagination,
									itemRender: (page, type, originalElement) => {
										if (type === 'page') {
											const reversedPage = totalRecords - page + 1;
											return <a>{reversedPage}</a>;
										}
										return originalElement;
									},
								}
							}
							bordered
							locale={{ emptyText: 'No Records Found' }}
							footerBg="#f0f0f0"
							rowKey="notes_id"
						/>
						</div>
					</Spin>
				</Form>
				{/* {noteValue && notesModel(hideModal, notesVisible, onchangeNoteValue, createNote, getForm, noteValue, noteTypeValue, isDisableNoteType, DOB(noteDate.month, handleNoteMonthChange, noteDate.date, handleNoteDayChange, noteDate.year, handleNoteYearChange, "Date", false), onSessionChange, sessionChecked, isSessionPresent, nextPreviousButton, isEdit, assessmentBehavior, handleAssessmentBehaviorChange)} */}
				{noteValue && (
					<NotesModal
						hideModal={hideModal}
						notesVisible={notesVisible}
						onchangeNoteValue={onchangeNoteValue}
						createNote={createNote}
						getForm={getForm}
						noteValue={noteValue}
						noteTypeValue={noteTypeValue}
						disable={isDisableNoteType}
						date={DOB(
							noteDate.month,
							handleNoteMonthChange,
							noteDate.date,
							handleNoteDayChange,
							noteDate.year,
							handleNoteYearChange,
							"Date",
							false
						)}
						onSessionChange={onSessionChange}
						sessionChecked={sessionChecked}
						isSessionPresent={isSessionPresent}
						nextPreviousButton={nextPreviousButton}
						isEdit={isEdit}
						assessmentBehavior={assessmentBehavior}
						handleAssessmentBehaviorChange={handleAssessmentBehaviorChange}
						notefollowUp={notefollowUp}
						onFollowUpChange={onFollowUpChange}
					/>
				)}
			</div>
		</div>
	);
};
export default NoteList;